import * as React from 'react';
import * as _ from 'lodash';
import classNames from 'classnames';
import { cleanProps } from '../../../utilities/props';
import { ProjectScopeIcons as iconOptions } from '../../../components/ProjectScope/NewFeatureGroup';
export default function () {
    function onClick1() {
        this.handleClose();
    }
    function onClick2(option, optionIndex) {
        this.selectCategoryImage(option);
    }
    function repeatOption3(option, optionIndex) {
        return [React.createElement('li', {
                'className': 'ui-icons-list__item ' + (this.isSelectedImage(option) ? 'ui-icons-list__item--selected' : '') + '\r\n            ' + (this.isLastImage(optionIndex) ? 'ui-icons-list__item--no-border-bottom' : ''),
                'style': this.getImageStyle(option),
                'onClick': onClick2.bind(this, option, optionIndex),
                'key': '6311'
            })];
    }
    return React.createElement('div', { 'className': 'fabricators-popup-container' }, React.createElement('div', { 'className': 'ui-popup' }, React.createElement('div', { 'className': 'ui-popup-header' }, React.createElement('span', { 'className': 'ui-popup-header__text' }, this.state.headerText), React.createElement('button', {
        'className': 'ui-popup-header__close',
        'onClick': onClick1.bind(this)
    })), React.createElement('div', { 'className': 'ui-popup-body ui-popup-body--small' }, React.createElement.apply(this, [
        'ul',
        { 'className': 'ui-icons-list' },
        _.map(iconOptions, repeatOption3.bind(this))
    ]))));
}